
import { mapState } from 'vuex'
import { bestSellersId, accessoriesId } from '@/utils/constants'
import EmptyBasketClouds from '@/static/svg/basket/empty-basket-clouds.svg'
import GlobalImageBasketClouds from '@/static/svg/account/global-image-basket-clouds.svg'

import SearchBar from '@/components/SearchBar'
import HeroButton from '@/components/HeroButton'

export default {
  components: {
    HeroButton,
    SearchBar,
    EmptyBasketClouds,
    GlobalImageBasketClouds,
  },
  props: {
    heading: {
      type: String,
      default: '',
    },
    largeHeading: {
      type: Boolean,
      default: true,
    },
    subHeading: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['search']),
  },
  methods: {
    async getAutocompleteResults(query) {
      await this.$store.dispatch('search/getAutocompleteResults', query)
    },
    goToContactLenses() {
      this.$router.push(this.$getLink(`/brand/${bestSellersId}`))
    },
    goToAccessories() {
      this.$router.push(this.$getLink(`/category/${accessoriesId}`))
    },
  },
}
